import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/hr',
    children: [
      { path: 'home', name: 'hr-home', component: () => import('@/modules/hr/HrHome.vue') },
      { path: 'payroll', name: 'hr-payroll', component: () => import('@/modules/hr/PayrollList.vue') },
      { path: 'employees', name: 'hr-employees', component: () => import('@/modules/hr/EmployeeList.vue') },
      { path: 'attendance', name: 'hr-attendance', component: () => import('@/modules/hr/AttendanceList.vue') },
      { path: 'payroll-calc', name: 'hr-payroll-calc', component: () => import('@/modules/hr/PayrollCalc.vue') }
    ]
  }
]

export default routes
